import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import employmentContractService from "services/EmploymentContractService";
import { cloneDeep } from "lodash";
import Utils from "utils";
// Async thunk to fetch contract settings
export const getContractList = createAsyncThunk(
  "contractSlice/getContractList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await employmentContractService.GetContractList(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const updateContractList = createAsyncThunk(
  "contractSlice/updateContractList",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.UpdateContractList(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const createContractList = createAsyncThunk(
  "contractSlice/createContractList",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.CreateContractList(data);
      if (onSuccess) onSuccess(response.data);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const deleteContractList = createAsyncThunk(
  "contractSlice/deleteContractList",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await employmentContractService.DeleteContract(id);
      if (onSuccess) onSuccess(response);
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const deleteEContract = createAsyncThunk(
  "contractSlice/deleteEContract",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await employmentContractService.DeleteEContract(id);
      if (onSuccess) onSuccess(response);
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const stopContractList = createAsyncThunk(
  "contractSlice/stopContractList",
  async (data, { rejectWithValue, dispatch }) => {
    const { onSuccess } = data;
    try {
      const response = await employmentContractService.StopContract(data);
      if (onSuccess) onSuccess(response);
      dispatch(getContractById({ id: response.data }));
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getContractById = createAsyncThunk(
  "contractSlice/getContractById",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await employmentContractService.GetContractById(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

//--->E Contract
export const getEContractList = createAsyncThunk(
  "contractSlice/getEContractList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await employmentContractService.getEContractList(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getEContractById = createAsyncThunk(
  "contractSlice/getEContractById",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await employmentContractService.getEContractById(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const UploadEContractList = createAsyncThunk(
  "contractSlice/UploadEContractList",
  async (data, { rejectWithValue }) => {

    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.UploadEContractList(data.transId);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const EContractExportDefault = createAsyncThunk(
  "contractSlice/EContractExportDefault",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data || {};
      const response = await employmentContractService.exportDefaultEContract(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertEcontract = createAsyncThunk(
  "contractSlice/upsertEcontract",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.upsertEcontract(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ViewPdfContract = createAsyncThunk(
  "contractSlice/ViewPdfContract",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.ViewPdfContract(payload.ContractId);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const XuatEContract = createAsyncThunk(
  "contractSlice/XuatEContract",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.XuatEContract({ ContractId: payload.ContractId, branchId: payload.branchId, loaiTaiLieuId: payload.loaiTaiLieuId });
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      // Giữ lại lý do thật từ BE (600 trả { description }) để hiện trong tổng kết upload hàng loạt.
      return rejectWithValue(err?.response?.data?.description || err.message || "Error");
    }
  }
);

export const getDmLoaiTaiLieuVnpt = createAsyncThunk(
  "contractSlice/getDmLoaiTaiLieuVnpt",
  async (data, { rejectWithValue }) => {
    try {
      const { branchId, onSuccess } = data || {};
      const response = await employmentContractService.DanhMucLoaiTaiLieuVnpt(branchId);
      if (onSuccess) onSuccess(response);
      // interceptor unwrap -> response = { data: { data: [...], isOk } }
      return response?.data?.data ?? [];
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const EContractSigedAction = createAsyncThunk(
  "contractSlice/EContractSigedAction",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.EContractSigedAction(payload);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getEContractSiged = createAsyncThunk(
  "contractSlice/getEContractSiged",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.GetEContractSiged(payload.contractId);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const SetEcontractSignedViTri = createAsyncThunk(
  "contractSlice/SetEcontractSignedViTri",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.SetEcontractSignedViTri(data);
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const TaiEContract = createAsyncThunk(
  "contractSlice/TaiEContract",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.TaiEContract({ contractId: data.contractId, branchId: data.branchId });
      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GuiHdChoCacBenKy = createAsyncThunk(
  "contractSlice/GuiHdChoCacBenKy",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await employmentContractService.GuiHdChoCacBenKy({ contractId: data.contractId, branchId: data.branchId });
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DongBoTrangThaiKy = createAsyncThunk(
  "contractSlice/DongBoTrangThaiKy",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await employmentContractService.DongBoTrangThaiKy({ contractId: data.contractId, branchId: data.branchId });
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const KySmartCaTatCa = createAsyncThunk(
  "contractSlice/KySmartCaTatCa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await employmentContractService.KySmartCaTatCa({ contractId: data.contractId, branchId: data.branchId });
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

// Đồng bộ trạng thái + file preview VNPT cho tất cả HĐ đang ký dở.
export const DongBoTrangThaiKyTatCa = createAsyncThunk(
  "contractSlice/DongBoTrangThaiKyTatCa",
  async (data = {}, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await employmentContractService.DongBoTrangThaiKyTatCa();
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

// v3: Get danh sách vị trí ký từ upload VNPT (parse từ dsViTriKy)
export const getEContractSignedList = createAsyncThunk(
  "contractSlice/getEContractSignedList",
  async (contractId, { rejectWithValue }) => {
    try {
      const response = await employmentContractService.getEContractSigned(contractId);
      return response.data.Data || [];
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

// v3: Update gán nhân viên vào vị trí ký
export const updateEContractSigned = createAsyncThunk(
  "contractSlice/updateEContractSigned",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.EContractSigedAction(payload);
      if (onSuccess) onSuccess(response);
      // Reload danh sách sau khi update
      if (data.contractId) {
        dispatch(getEContractSignedList(data.contractId));
      }
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

// v3: Upload tạo hợp đồng từ mẫu VNPT - lấy vị trí ký từ mẫu
export const TaoHopDongVNPT_TuHdMau = createAsyncThunk(
  "contractSlice/TaoHopDongVNPT_TuHdMau",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { contractId, branchId, onSuccess } = data;
      const response = await employmentContractService.TaoHopDongVNPT_TuHdMau({ contractId, branchId });
      if (onSuccess) onSuccess(response);
      // Load vị trí ký từ upload mẫu
      if (contractId) {
        dispatch(getEContractSignedList(contractId));
      }
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


const initialState = {
  loading: false,
  contractList: [],

  contractDetail: {
    data: null,
    loading: false,
  },

  eContractList: [],
  eContractDetail: {},
  eContractSigedList: [],
  dmLoaiTaiLieuVnptList: [],
};

const contractSlice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    updateInitForm: (state, action) => {
      state.initForm = { ...state.initForm, ...action.payload };
    },

    resetContractDetail: (state) => {
      state.contractDetail = initialState.contractDetail;
    },

    reseteContractDetail: (state) => {
      state.eContractDetail = initialState.eContractDetail;
    },
  },
  extraReducers: (builder) => {
    builder

      //getEContractById
      .addCase(getEContractById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEContractById.fulfilled, (state, action) => {
        state.loading = false;

        state.eContractDetail = {
          ...action.payload,
          ngayBatDau: Utils.convertMomentToDate(action.payload.ngayBatDau),
          ngayHetHan: Utils.convertMomentToDate(action.payload.ngayHetHan),
        };
      })
      .addCase(getEContractById.rejected, (state) => {
        state.loading = false;
      })
      //getDmLoaiTaiLieuVnpt
      .addCase(getDmLoaiTaiLieuVnpt.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDmLoaiTaiLieuVnpt.fulfilled, (state, action) => {
        state.loading = false;
        state.dmLoaiTaiLieuVnptList = action.payload;
      })
      .addCase(getDmLoaiTaiLieuVnpt.rejected, (state) => {
        state.loading = false;
      })
      //getEContractSiged
      .addCase(getEContractSiged.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEContractSiged.fulfilled, (state, action) => {
        state.loading = false;
        state.eContractSigedList = action.payload;
      })
      .addCase(getEContractSiged.rejected, (state) => {
        state.loading = false;
      })
      //getEContractById
      .addCase(getEContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEContractList.fulfilled, (state, action) => {
        state.loading = false;
        state.eContractList = action.payload;
      })
      .addCase(getEContractList.rejected, (state) => {
        state.loading = false;
      })
      //getContractList
      .addCase(getContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContractList.fulfilled, (state, action) => {
        state.loading = false;
        state.contractList = action.payload.result;
      })
      .addCase(getContractList.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateContractList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateContractList.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createContractList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createContractList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(stopContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(stopContractList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(stopContractList.rejected, (state) => {
        state.loading = false;
      })

      // v3: getEContractSignedList
      .addCase(getEContractSignedList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEContractSignedList.fulfilled, (state, action) => {
        state.loading = false;
        state.eContractSigedList = action.payload;
      })
      .addCase(getEContractSignedList.rejected, (state) => {
        state.loading = false;
      })

      // v3: updateEContractSigned
      .addCase(updateEContractSigned.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEContractSigned.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEContractSigned.rejected, (state) => {
        state.loading = false;
      })

      // v3: TaoHopDongVNPT_TuHdMau
      .addCase(TaoHopDongVNPT_TuHdMau.pending, (state) => {
        state.loading = true;
      })
      .addCase(TaoHopDongVNPT_TuHdMau.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(TaoHopDongVNPT_TuHdMau.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteContractList.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteContractList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteContractList.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getContractById.pending, (state) => {
        state.loading = true;
        state.contractDetail = { ...state.contractDetail, loading: true };
      })
      .addCase(getContractById.fulfilled, (state, action) => {
        state.loading = false;
        state.contractDetail = { data: action.payload, loading: false };
      })
      .addCase(getContractById.rejected, (state, action) => {
        state.loading = false;
        state.contractDetail = { ...state.contractDetail, loading: false };
      });
  },
});
export const { updateInitForm, resetContractDetail, reseteContractDetail } = contractSlice.actions;

export default contractSlice.reducer;
